export default function getSearchFiltersDialogMountParent(stackAboveModals) {
  if (typeof document === 'undefined') return null;
  if (stackAboveModals) {
    return document.getElementById('dialogRoot') || document.body;
  }
  return document.body;
}
